import React from "react";
import { Box, Paper, Stack, Typography, Button, Chip } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { notificationService } from "../../api/services/slaService";
import { PageHeader, Loader, EmptyState } from "../../components/Common";

export default function NotificationsPage() {
  const queryClient = useQueryClient();
  const { data: notifications, isLoading } = useQuery({ queryKey: ["notifications", "all"], queryFn: () => notificationService.list(false) });

  const markReadMutation = useMutation({
    mutationFn: (id) => notificationService.markRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });

  const markAllReadMutation = useMutation({
    mutationFn: notificationService.markAllRead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["notifications"] }),
  });

  if (isLoading) return <Loader label="Loading notifications..." />;

  return (
    <Box>
      <PageHeader
        title="Notifications"
        action={<Button variant="outlined" onClick={() => markAllReadMutation.mutate()}>Mark All Read</Button>}
      />

      {(!notifications || notifications.length === 0) ? (
        <EmptyState title="You're all caught up" />
      ) : (
        <Stack spacing={1.5}>
          {notifications.map((n) => (
            <Paper
              key={n.id} variant="outlined"
              sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center", bgcolor: n.is_read ? "transparent" : "#F7F7F7" }}
            >
              <Box>
                <Stack direction="row" spacing={1} alignItems="center">
                  {!n.is_read && <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#000" }} />}
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>{n.title}</Typography>
                  <Chip size="small" label={n.type} />
                </Stack>
                {n.message && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{n.message}</Typography>}
                <Typography variant="caption" color="text.secondary">{new Date(n.created_at).toLocaleString()}</Typography>
              </Box>
              {!n.is_read && (
                <Button size="small" onClick={() => markReadMutation.mutate(n.id)}>Mark read</Button>
              )}
            </Paper>
          ))}
        </Stack>
      )}
    </Box>
  );
}
